import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCO9CFS5_YwttUKBNlUG09ZFbC2mLDwjbY",
  authDomain: "smb-admin-bd32d.firebaseapp.com",
  projectId: "smb-admin-bd32d",
  storageBucket: "smb-admin-bd32d.appspot.com",
  messagingSenderId: "XXXXXXX",
  appId: "XXXXXXX"
};

const app = initializeApp(firebaseConfig);

// ✅ IMPORTANT EXPORTS
export const db = getFirestore(app);
export const storage = getStorage(app);